import store from '@/store';
import perimetersConfApi from '@/api/PerimetersConfApi';
import * as types from './mutation-types';


/**
 * Action fired when the perimeter will be fetched.
 *
 * @param {function} commit Commit function to update the store.
 * @param {function} fn     Callback to edit the parameters on the api.
 */

const all = ({ commit }, fn = null) => {
  if (typeof fn === 'function') {
    fn(perimetersConfApi);
  }

  store.dispatch('application/startLoading');
  return perimetersConfApi.all()
    .then((response) => {
      store.dispatch('application/finishLoading');
      const data = {
        perimeters: response.data,
        pagination: response.pagination,
      };
      commit(types.ALL, data);
      return data;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de la récupération de la liste des périmètres',
      });
      return Promise.reject(error);
    });
};


/**
 * Action fired when the options  will be fetched.
 *
 * @param {function} commit Commit function to update the store.
 */

const allOptions = ({ commit }) => {
  store.dispatch('application/startLoading');
  return perimetersConfApi.allOptions()
    .then((response) => {
      store.dispatch('application/finishLoading');
      const data = {
        options: response,
      };
      commit(types.ALL_OPTIONS, data);
      return data;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de la récupération de la liste d\'options',
      });
      return Promise.reject(error);
    });
};

/**
 * Action fired when we create a new perimeter.
 *
 * @param {object}   data   data needed for new perimeter
 * @param {function} commit Commit function to update the store.
 */

// eslint-disable-next-line
const create = ({ commit }, data) => {

  store.dispatch('application/startLoading');

  return perimetersConfApi.create(data)
    // eslint-disable-next-line consistent-return
    .then((response) => {
      if (response.data.status !== 'error') {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: 'Périmètre créé avec succès!',
        });
        return response;
      }

      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de la création du périmètre.',
      });
    });
};

/**
 * Action fired when we update a new perimeter.
 *
 * @param {object}   data   data needed for updating perimeter
 * @param {function} commit Commit function to update the store.
 */

// eslint-disable-next-line
const updatePerimeter = ({ commit }, data) => {
  store.dispatch('application/startLoading');
  return perimetersConfApi.updatePerimeter(data)
    .then((response) => {
      const options = Object.entries(data.option).map(([name, value]) => ({ name, value }));
      store.dispatch('application/finishLoading');
      const selectedData = {
        selectedName: data.name,
        selectedDescription: data.description,
        selectedOptions: options,
        selectedUsers: data.users,
      };
      store.dispatch('perimeters/getSelectedPerimeter', selectedData);
      store.dispatch('application/openSnackbar', {
        message: 'Périmètre mis à jour avec succès',
      });
      return response;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de la mise à jour du périmètre',
      });
      return Promise.reject(error);
    });
};

/**
 * Action fired to get all users.
 *
 * @param {function} fn     Callback to edit the parameters on the api.
 * @param {function} commit Commit function to update the store.
 */

// eslint-disable-next-line
const allUsers = ({ commit }, fn = null) => {
  if (typeof fn === 'function') {
    fn(perimetersConfApi);
  }
  store.dispatch('application/startLoading');

  return perimetersConfApi.allUsers()
    .then((response) => {
      store.dispatch('application/finishLoading');
      const data = {
        users: response.data,
        pagination: response.pagination,
      };
      commit(types.ALL_USERS, data);
      return data;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Echec lors de la récupération des utilisateurs',
      });
      return Promise.reject(error);
    });
};

/**
 * Action fired when we create a new user.
 *
 * @param {object}   data   data needed for creating a new user.
 * @param {function} commit Commit function to update the store.
 */

// eslint-disable-next-line
const createUser = ({ commit }, data) => {

  store.dispatch('application/startLoading');

  return perimetersConfApi.createUser(data)
    .then((response) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Utilisateur créé avec succès!',
      });
      return response;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de la création de l\'utilisateurs.',
      });
      return Promise.reject(error);
    });
};

/**
 * Action fired when we update a new user.
 *
 * @param {object}   data   data needed for updating a user.
 * @param {function} commit Commit function to update the store.
 */

// eslint-disable-next-line
const updateUser = ({ commit }, data) => {
  store.dispatch('application/startLoading');
  return perimetersConfApi.updateUser(data)
    .then((response) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Utilisateur  mis  à jour avec succès',
      });
      return response;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de la mise à jour de l\'utilisateur',
      });
      return Promise.reject(error);
    });
};

/**
 * Action fired when we assign a user to a perimeter.
 *
 * @param {object}   data   data needed for assigning a user to a perimeter.
 * @param {function} commit Commit function to update the store.
 */

// eslint-disable-next-line
const assignUser = ({ commit }, data) => {

  store.dispatch('application/startLoading');

  return perimetersConfApi.AssignUser(data.userId, data.perimeterName)
    .then((response) => {
      store.dispatch('perimeters/getSelectedPerimeter', data.selectedPerimeter);
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Utilisateur affecté avec succès!',
      });
      return response;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de l\'affectation de l\'utilisateurs.',
      });
      return Promise.reject(error);
    });
};


/**
 * Action fired when the pagination needs to be updated.
 *
 */

const setCurrentPage = ({ commit }, currentPage) => {
  commit(types.SET_CURRENT_PAGE, currentPage);
};


/**
 * Action fired when the pagination needs to be updated.
 *
 */

const setCurrentPageUser = ({ commit }, currentPage) => {
  commit(types.SET_CURRENT_PAGE_USER, currentPage);
};

/**
* Action fired when data about a selected perimeter needs to be updated.
*
* @param {object} selectedPerimeter data about a selected perimeter
*/

const getSelectedPerimeter = ({ commit }, selectedPerimeter) => {
  commit(types.GET_SELECTED_PERIMETER, selectedPerimeter);
};


export default {
  all,
  allOptions,
  create,
  updatePerimeter,
  allUsers,
  createUser,
  assignUser,
  updateUser,
  setCurrentPage,
  setCurrentPageUser,
  getSelectedPerimeter,
};



// WEBPACK FOOTER //
// ./src/store/modules/perimeters/actions.js